<template>
  <Teleport to="body">
    <div v-if="visible" class="fixed inset-0 z-50 overflow-y-auto">
      <!-- 遮罩层 -->
      <div class="fixed inset-0 bg-black/50 transition-opacity" @click="handleClose"></div>

      <!-- 弹窗主体 -->
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative w-full max-w-3xl bg-white rounded-2xl shadow-xl transform transition-all max-h-[90vh] flex flex-col">
          <!-- 头部 -->
          <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200 flex-shrink-0">
            <h3 class="text-lg font-semibold text-slate-900">{{ isEdit ? '编辑分账账户' : '创建分账账户' }}</h3>
            <button
              @click="handleClose"
              class="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>

          <!-- 表单内容 -->
          <div class="flex-1 overflow-y-auto p-6">
            <el-form
              ref="formRef"
              :model="formData"
              :rules="rules"
              label-width="120px"
              class="space-y-6"
            >
              <!-- 基本信息 -->
              <div class="bg-slate-50 rounded-xl p-4">
                <h4 class="text-sm font-medium text-slate-700 mb-4 flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  基本信息
                </h4>

                <el-form-item label="分账接收方" prop="receiverName">
                  <input
                    v-model="formData.receiverName"
                    type="text"
                    placeholder="请输入分账接收方名称"
                    class="form-input w-full"
                  >
                </el-form-item>

                <el-form-item label="联系手机" prop="contactMobile">
                  <input
                    v-model="formData.contactMobile"
                    type="text"
                    placeholder="请输入联系电话"
                    class="form-input w-full"
                  >
                </el-form-item>
              </div>

              <!-- 账户类型 -->
              <div class="bg-slate-50 rounded-xl p-4">
                <h4 class="text-sm font-medium text-slate-700 mb-4 flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                  </svg>
                  收款账户信息
                </h4>

                <el-form-item label="账户类型" prop="acctTypeCode">
                  <select
                    v-model="formData.acctTypeCode"
                    :disabled="isEdit"
                    class="form-select-native w-full"
                  >
                    <option value="">请选择账户类型</option>
                    <option value="57">对公账户</option>
                    <option value="58">对私账户</option>
                  </select>
                </el-form-item>

                <el-form-item label="收款账户名" prop="acctName">
                  <input
                    v-model="formData.acctName"
                    type="text"
                    placeholder="请输入收款账户名称"
                    class="form-input w-full"
                  >
                </el-form-item>

                <el-form-item label="收款账号" prop="acctNo">
                  <input
                    v-model="formData.acctNo"
                    type="text"
                    placeholder="请输入收款账户卡号"
                    class="form-input w-full font-mono"
                  >
                </el-form-item>

                <div v-if="requiresManualBankInfo" class="grid grid-cols-2 gap-4">
                  <el-form-item label="开户行号" prop="acctOpenBankCode">
                    <input
                      v-model="formData.acctOpenBankCode"
                      type="text"
                      placeholder="请输入开户行号"
                      class="form-input w-full"
                    >
                  </el-form-item>

                  <el-form-item label="清算行行号" prop="acctClearBankCode">
                    <input
                      v-model="formData.acctClearBankCode"
                      type="text"
                      placeholder="请输入清算行行号"
                      class="form-input w-full"
                    >
                  </el-form-item>
                </div>

                <el-form-item v-if="requiresManualBankInfo" label="开户行名称" prop="acctOpenBankName">
                  <input
                    v-model="formData.acctOpenBankName"
                    type="text"
                    placeholder="请输入开户行名称"
                    class="form-input w-full"
                  >
                </el-form-item>

                <el-form-item label="账户证件类型" prop="acctCertificateType">
                  <select
                    v-model="formData.acctCertificateType"
                    class="form-select-native w-full"
                  >
                    <option value="">请选择证件类型</option>
                    <option value="17">身份证</option>
                    <option value="18">护照</option>
                    <option value="19">港澳居民来往内地通行证</option>
                    <option value="20">台湾居民来往内地通行证</option>
                  </select>
                </el-form-item>

                <el-form-item label="账户证件号" prop="acctCertificateNo">
                  <input
                    v-model="formData.acctCertificateNo"
                    type="text"
                    placeholder="请输入账户证件号"
                    class="form-input w-full font-mono"
                  >
                </el-form-item>
              </div>

              <!-- 营业执照信息（对公账户必填） -->
              <div v-if="formData.acctTypeCode === '57'" class="bg-amber-50 rounded-xl p-4">
                <h4 class="text-sm font-medium text-amber-800 mb-4 flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                  </svg>
                  营业执照信息
                </h4>

                <el-form-item label="营业执照号" prop="licenseNo">
                  <input
                    v-model="formData.licenseNo"
                    type="text"
                    placeholder="请输入营业执照号码"
                    class="form-input w-full"
                  >
                </el-form-item>

                <el-form-item label="营业执照名" prop="licenseName">
                  <input
                    v-model="formData.licenseName"
                    type="text"
                    placeholder="请输入营业执照名称"
                    class="form-input w-full"
                  >
                </el-form-item>
              </div>

              <!-- 法人信息（对公账户必填） -->
              <div v-if="formData.acctTypeCode === '57'" class="bg-amber-50 rounded-xl p-4">
                <h4 class="text-sm font-medium text-amber-800 mb-4 flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                  法人信息
                </h4>

                <el-form-item label="法人姓名" prop="legalPersonName">
                  <input
                    v-model="formData.legalPersonName"
                    type="text"
                    placeholder="请输入法人姓名"
                    class="form-input w-full"
                  >
                </el-form-item>

                <div class="grid grid-cols-2 gap-4">
                  <el-form-item label="法人证件类型" prop="legalPersonCertificateType">
                    <select
                      v-model="formData.legalPersonCertificateType"
                      class="form-select-native w-full"
                    >
                      <option value="">请选择证件类型</option>
                      <option value="17">身份证</option>
                      <option value="18">护照</option>
                      <option value="19">港澳居民来往内地通行证</option>
                      <option value="20">台湾居民来往内地通行证</option>
                    </select>
                  </el-form-item>

                  <el-form-item label="法人证件号" prop="legalPersonCertificateNo">
                    <input
                      v-model="formData.legalPersonCertificateNo"
                      type="text"
                      placeholder="请输入法人证件号"
                      class="form-input w-full font-mono"
                    >
                  </el-form-item>
                </div>
              </div>

              <div v-if="!isEdit" class="bg-slate-50 rounded-xl p-4">
                <h4 class="text-sm font-medium text-slate-700 mb-4 flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.586-6.586a4 4 0 10-5.657-5.657l-7.071 7.071a6 6 0 108.485 8.485L20.5 13"/>
                  </svg>
                  合作协议（可选）
                </h4>
                <input
                  ref="agreementFileInputRef"
                  type="file"
                  accept=".jpg,.png,.pdf"
                  class="hidden"
                  @change="handleAgreementFileChange"
                >
                <div class="flex items-center gap-3">
                  <button
                    type="button"
                    class="btn-secondary"
                    :disabled="submitting || saveCompleted"
                    @click="agreementFileInputRef?.click()"
                  >
                    选择文件
                  </button>
                  <div class="min-w-0 flex-1 text-sm text-slate-600 truncate">
                    {{ selectedAgreementFileName || '未选择文件' }}
                  </div>
                  <button
                    v-if="selectedAgreementFile"
                    type="button"
                    class="text-sm text-slate-500 hover:text-slate-700 transition-colors"
                    :disabled="submitting || saveCompleted"
                    @click="clearAgreementFile"
                  >
                    移除
                  </button>
                </div>
              </div>
            </el-form>
          </div>

          <div v-if="saveCompleted && !isEdit && savedReceiver" class="px-6 pb-4">
            <div class="rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800">
              分账账户已保存。可以现在上传合作协议并发起绑定，也可以稍后再绑定。
            </div>
          </div>

          <!-- 底部按钮 -->
          <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-2xl flex-shrink-0">
            <template v-if="saveCompleted && !isEdit">
              <button
                @click="handleClose"
                class="btn-secondary"
              >
                稍后绑定
              </button>
              <button
                @click="handleContinueBind"
                class="btn-primary"
              >
                继续绑定
              </button>
            </template>
            <template v-else>
              <button
                @click="handleClose"
                class="px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-100 transition-colors"
              >
                取消
              </button>
              <button
                @click="handleSubmit"
                :disabled="submitting"
                class="btn-primary"
              >
                <span v-if="submitting">{{ submittingText }}</span>
                <span v-else>{{ submitButtonText }}</span>
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, reactive, watch, computed } from 'vue'
import { ElMessage } from 'element-plus'
import {
  createDefaultReferrerFranchiseeBind,
  createReferrerLakalaReceiver,
  updateReferrerLakalaReceiver,
  uploadCommissionLakalaFile
} from '@/api/commission'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  referrerId: {
    type: [Number, String],
    default: null
  },
  accountData: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:visible', 'success'])

const formRef = ref(null)
const agreementFileInputRef = ref(null)
const submitting = ref(false)
const savedReceiver = ref(null)
const saveCompleted = ref(false)
const selectedAgreementFile = ref(null)
const selectedAgreementFileName = ref('')

const AGREEMENT_MAX_FILE_SIZE = 5 * 1024 * 1024
const AGREEMENT_ALLOWED_EXTENSIONS = ['jpg', 'png', 'pdf']
const AGREEMENT_ALLOWED_TYPES = ['image/jpeg', 'image/png', 'application/pdf']

// 是否是编辑模式
const isEdit = computed(() => !!props.accountData)
const requiresManualBankInfo = computed(() => formData.acctTypeCode === '57')
const submitButtonText = computed(() => selectedAgreementFile.value ? '保存并发起绑定' : '保存')
const submittingText = computed(() => selectedAgreementFile.value ? '保存并绑定中...' : '保存中...')

// 表单数据
const getInitialFormData = () => ({
  referrerId: null,
  receiverName: '',
  contactMobile: '',
  licenseNo: '',
  licenseName: '',
  legalPersonName: '',
  legalPersonCertificateType: '',
  legalPersonCertificateNo: '',
  acctNo: '',
  acctName: '',
  acctTypeCode: '',
  acctCertificateType: '',
  acctCertificateNo: '',
  acctOpenBankCode: '',
  acctOpenBankName: '',
  acctClearBankCode: ''
})

const formData = reactive(getInitialFormData())

// 验证规则
const rules = computed(() => {
  const baseRules = {
    receiverName: [
      { required: true, message: '请输入分账接收方名称', trigger: 'blur' }
    ],
    contactMobile: [
      { required: true, message: '请输入联系手机号', trigger: 'blur' },
      { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
    ],
    acctTypeCode: [
      { required: true, message: '请选择账户类型', trigger: 'change' }
    ],
    acctName: [
      { required: true, message: '请输入收款账户名称', trigger: 'blur' }
    ],
    acctNo: [
      { required: true, message: '请输入收款账户卡号', trigger: 'blur' }
    ]
  }

  if (requiresManualBankInfo.value) {
    baseRules.acctOpenBankCode = [
      { required: true, message: '请输入开户行号', trigger: 'blur' }
    ]
    baseRules.acctClearBankCode = [
      { required: true, message: '请输入清算行行号', trigger: 'blur' }
    ]
    baseRules.acctOpenBankName = [
      { required: true, message: '请输入开户行名称', trigger: 'blur' }
    ]
  }

  // 对公账户额外的验证
  if (formData.acctTypeCode === '57') {
    baseRules.licenseNo = [
      { required: true, message: '对公账户请输入营业执照号', trigger: 'blur' }
    ]
    baseRules.licenseName = [
      { required: true, message: '对公账户请输入营业执照名称', trigger: 'blur' }
    ]
    baseRules.legalPersonName = [
      { required: true, message: '对公账户请输入法人姓名', trigger: 'blur' }
    ]
    baseRules.legalPersonCertificateType = [
      { required: true, message: '对公账户请选择法人证件类型', trigger: 'change' }
    ]
    baseRules.legalPersonCertificateNo = [
      { required: true, message: '对公账户请输入法人证件号', trigger: 'blur' }
    ]
  }

  return baseRules
})

// 重置表单
const resetForm = () => {
  savedReceiver.value = null
  saveCompleted.value = false
  clearAgreementFile()
  if (props.accountData) {
    // 编辑模式 - 填充已有数据
    Object.keys(getInitialFormData()).forEach(key => {
      let value = props.accountData[key] ?? getInitialFormData()[key]
      // API 返回的 acctTypeCode 可能是整数，需要转为字符串用于表单判断
      if (key === 'acctTypeCode' && value !== null && value !== undefined) {
        value = String(value)
      }
      formData[key] = value
    })
  } else {
    // 新增模式
    const initial = getInitialFormData()
    Object.keys(initial).forEach(key => {
      formData[key] = initial[key]
    })
    formData.referrerId = props.referrerId
  }
}

const clearAgreementFile = () => {
  selectedAgreementFile.value = null
  selectedAgreementFileName.value = ''
  if (agreementFileInputRef.value) {
    agreementFileInputRef.value.value = ''
  }
}

const validateAgreementFile = (file) => {
  const extension = file.name?.split('.').pop()?.toLowerCase() || ''
  const extensionAllowed = AGREEMENT_ALLOWED_EXTENSIONS.includes(extension)
  const typeAllowed = !file.type || AGREEMENT_ALLOWED_TYPES.includes(file.type)

  if (!extensionAllowed || !typeAllowed) {
    ElMessage.error('合作协议仅支持 JPG、PNG、PDF 格式')
    return false
  }
  if (file.size > AGREEMENT_MAX_FILE_SIZE) {
    ElMessage.error('合作协议文件大小不能超过 5M')
    return false
  }
  return true
}

const handleAgreementFileChange = (event) => {
  const file = event.target.files?.[0]
  if (!file) return
  if (!validateAgreementFile(file)) {
    clearAgreementFile()
    return
  }
  selectedAgreementFile.value = file
  selectedAgreementFileName.value = file.name
}

// 关闭弹窗
const handleClose = () => {
  resetForm()
  emit('update:visible', false)
}

const handleContinueBind = () => {
  emit('success', { continueBind: true })
  handleClose()
}

const buildSubmitData = () => {
  const submitData = {
    ...formData,
    referrerId: props.referrerId ?? formData.referrerId,
    // 编辑时包含 id
    ...(isEdit.value ? { id: props.accountData.id } : {})
  }
  if (!requiresManualBankInfo.value) {
    delete submitData.acctOpenBankCode
    delete submitData.acctOpenBankName
    delete submitData.acctClearBankCode
  }
  return submitData
}

const uploadAgreementAndCreateBind = async (submitData) => {
  const formData = new FormData()
  formData.append('referrerId', submitData.referrerId)
  formData.append('attType', 'SPLIT_COOPERATION_FILE')
  formData.append('remark', '引入人与加盟商分账合作协议')
  formData.append('module', 'commission/referrer-bind')
  formData.append('file', selectedAgreementFile.value)
  const uploadedFile = await uploadCommissionLakalaFile(formData)
  await createDefaultReferrerFranchiseeBind(submitData.referrerId, {
    entrustFileName: uploadedFile.lakalaFileName,
    entrustFilePath: uploadedFile.lakalaFilePath
  })
}

// 提交表单
const handleSubmit = async () => {
  try {
    await formRef.value.validate()

    const submitData = buildSubmitData()
    if (!isEdit.value && !submitData.referrerId) {
      ElMessage.error('缺少引入人ID，无法创建分账账户')
      return
    }
    submitting.value = true

    if (isEdit.value) {
      // 编辑模式
      await updateReferrerLakalaReceiver(submitData)
      ElMessage.success('更新成功')
      emit('success', { continueBind: false })
      handleClose()
    } else {
      // 新增模式
      await createReferrerLakalaReceiver(submitData)
      savedReceiver.value = submitData
      saveCompleted.value = true
      emit('success', { continueBind: false })
      if (selectedAgreementFile.value) {
        try {
          await uploadAgreementAndCreateBind(submitData)
          ElMessage.success('分账账户已创建，绑定申请已提交')
          handleClose()
        } catch (bindError) {
          console.error('创建后提交绑定申请失败:', bindError)
          ElMessage.warning(bindError.message || '分账账户已创建，绑定申请提交失败，可稍后在详情页重新绑定')
        }
      } else {
        ElMessage.success('创建成功')
      }
    }
  } catch (error) {
    console.error('保存分账账户失败:', error)
    if (error !== false) {
      ElMessage.error(error.message || '保存失败')
    }
  } finally {
    submitting.value = false
  }
}

// 监听弹窗显示
watch(() => props.visible, (val) => {
  if (val) {
    resetForm()
  }
})
</script>
